import { Component, OnInit } from '@angular/core';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-plm-ops',
  templateUrl: './plm-ops.component.html',
  styleUrls: ['../plm-shared.css'],
})
export class PlmOpsComponent implements OnInit {
  projects: any[] = [];
  projectId: number | null = null;
  gps: any[] = [];
  fences: any[] = [];
  policies: any[] = [];
  overdue: any[] = [];
  reports: any[] = [];
  backups: any[] = [];
  tickets: any[] = [];
  gpsForm: any = { latitude: '', longitude: '', machine_id: '', heading: '', speed_kmh: '' };
  fenceForm: any = { name: '', latitude: '', longitude: '', delta: 0.002 };
  escForm: any = { name: '', stage: 'execution', sla_hours: 24 };
  reportForm: any = { report_type: 'dpr' };
  backupForm: any = { label: 'nightly', target: 's3' };
  omForm: any = { title: '', description: '', priority: 'medium' };

  constructor(private plm: PlmService, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => (this.projects = res?.data || []),
    });
    this.reload();
  }

  reload(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listGps().subscribe({ next: (r: any) => (this.gps = r.data || []) });
    this.plm.listGeofences(q).subscribe({ next: (r: any) => (this.fences = r.data || []) });
    this.plm.listEscalation().subscribe({ next: (r: any) => (this.policies = r.data || []) });
    this.plm.listReports(q).subscribe({ next: (r: any) => (this.reports = r.data || []) });
    this.plm.listBackup().subscribe({ next: (r: any) => (this.backups = r.data || []) });
    this.plm.listOm(q).subscribe({ next: (r: any) => (this.tickets = r.data || []) });
  }

  ingestGps(): void {
    this.plm.ingestGps({ ...this.gpsForm, project_id: this.projectId }).subscribe({
      next: (r: any) => {
        const n = r.breaches?.length || 0;
        this.toastr.success(n ? `GPS saved (${n} geofence alert${n === 1 ? '' : 's'})` : 'GPS saved');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addFence(): void {
    const lat = Number(this.fenceForm.latitude);
    const lng = Number(this.fenceForm.longitude);
    const d = Number(this.fenceForm.delta) || 0.002;
    const geometry = {
      type: 'Polygon',
      coordinates: [[
        [lng - d, lat - d],
        [lng + d, lat - d],
        [lng + d, lat + d],
        [lng - d, lat + d],
        [lng - d, lat - d],
      ]],
    };
    this.plm.createGeofence({ name: this.fenceForm.name, geometry, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Geofence created');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addPolicy(): void {
    this.plm.createEscalation({ ...this.escForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Policy saved');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  evaluate(): void {
    this.plm.evaluateEscalation().subscribe({
      next: (r: any) => {
        this.overdue = r.data || [];
        this.toastr.info(`${r.overdue || 0} overdue work item(s)`);
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addReport(): void {
    this.plm.createReport({ ...this.reportForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Report drafted');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  release(row: any): void {
    this.plm.releaseReport(row.id).subscribe({
      next: () => {
        this.toastr.success('Report released');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addBackup(): void {
    this.plm.createBackup(this.backupForm).subscribe({
      next: () => {
        this.toastr.success('Backup job added');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  runBackup(row: any): void {
    this.plm.runBackup(row.id).subscribe({
      next: () => {
        this.toastr.success('Backup marker recorded');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addOm(): void {
    this.plm.createOm({ ...this.omForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('O&M ticket opened');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  closeOm(row: any): void {
    this.plm.updateOm(row.id, { status: 'closed' }).subscribe({
      next: () => this.reload(),
    });
  }
}
